import script from "./AppAssetStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppAssetStatus.vue?vue&type=script&lang=ts&setup=true"

import "./AppAssetStatus.vue?vue&type=style&index=0&id=c5449612&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5449612"]])

export default __exports__